import { useCompetitionRegistrationCategorySummaryQuery } from '~/pages/competition/set-category/queries';
import { useCategoriesListQuery } from '~/pages/categories/queries';
import { useCompetitionQuery } from '~/pages/competition/queries';
import { Schema } from './register-lifter-form-schema';
import { useFormContext } from 'react-hook-form';
import { useParams } from '~/hooks/useParams';
import { Input } from '~/components/Input';
import { idParamSchema } from '~/schemas';
import { useMemo } from 'react';

export function RegisterLifterAgeCategory() {
  const { formState, register, watch, resetField, getValues } = useFormContext<Schema>();
  const { id } = useParams(idParamSchema.parse);

  const personId = watch('person_id') ? Number(watch('person_id')) : undefined;

  const { data: competition, isLoading: isLoadingCompetition } = useCompetitionQuery(id);
  const { data = [], isLoading } = useCompetitionRegistrationCategorySummaryQuery(id);

  const { data: ageCategories = [], isLoading: isLoadingAgeCategories } = useCategoriesListQuery({
    person: personId,
    date: competition?.start_date ?? undefined,
  });

  const competitionTypeId = Number(watch('competition_type_id'));
  const competitionType = data.find(d => d.competition_type.id === competitionTypeId);

  const options = useMemo(() => {
    return (competitionType?.age_categories ?? [])
      .filter(a => ageCategories?.map(b => b.id).includes(a.age_category.id))
      .map(d => [d.age_category.label, d.age_category.id] as [string, number]);
  }, [competitionType, ageCategories]);

  function handleChange() {
    if (!getValues('weight_class_id')) {
      return;
    }

    resetField('weight_class_id');
  }

  return (
    <Input.Select
      {...register('category_id', { onChange: handleChange })}
      disabled={isLoading || isLoadingAgeCategories || isLoadingCompetition || !competitionTypeId || !personId}
      defaultValue={watch('category_id') ?? undefined}
      placeholder="Välj kategori"
      formState={formState}
      options={options}
      name="category_id"
    />
  );
}
